import { createRouter,createWebHashHistory } from "vue-router";
import store from '@/store'
import util from '@/util/util'

// 主后台管理
// 学校界面
import admin from '@/pages/admin/home.vue'

// 路由规则
const routes = [
	{
		path: '/',
		redirect: '/login',
        meta: {
            title: '管理端登录'
        }
	},
    {
        name: '后台登录',
        path:'/login',
        component: () => import('@/pages/login/index.vue'),
        meta: {
            title: '管理端登录'
        }
    },
    // 设置端
    {

        meta: {
            title: '设置端'
        },
        path:'/admin',
        component:admin,
        children: [
            {
                // '后台首页',
                path: 'index/index',
                component: () => import('@/pages/admin/index/index.vue')
            },

            // 文件
            {
                // '文件',
                path: 'file/file',
                component: () => import('@/pages/admin/file/file.vue')
            },

            // 系统管理管理
            
            // 导航管理
                {
                    // '主后台',
                    path: 'config/nav/:state',
                    component: () => import('@/pages/admin/config/nav/nav.vue')
                },
            // 导航管理

            // 管理员
                {
                    // '管理员',
                    path: 'user/user',
                    component: () => import('@/pages/admin/user/user.vue')
                },
                {
                    // '日志',
                    path: 'user/log',
                    component: () => import('@/pages/admin/user/log.vue')
                },
                {
                    // '权限',
                    path: 'user/rank',
                    component: () => import('@/pages/admin/user/rank.vue')
                },
                {
                    // '权限',
                    path: 'user/rankPhone',
                    component: () => import('@/pages/admin/user/rankPhone.vue')
                },
            // 管理员

            // 后台管理
                {
                    // '后台列表',
                    path: 'agency/agency',
                    component: () => import('@/pages/admin/agency/agency.vue')
                },
                {
                    // '管理员',
                    path: 'agency/user/:agencyId',
                    component: () => import('@/pages/admin/agency/user.vue')
                },
            // 后台管理
            
        ],
    },

    // 后台
    {

        meta: {
            title: '后台'
        },
        path:'/agency',
        component: () => import('@/pages/agency/home.vue'),
        children: [
            {
                // '后台首页',
                path: 'index/index',
                component: () => import('@/pages/agency/index/index.vue')
            },

            // 文件
            {
                // '文件',
                path: 'file/file',
                component: () => import('@/pages/agency/tool/file.vue')
            },

            {
                // '文件',
                path: 'tool/agreement',
                component: () => import('@/pages/agency/tool/agreement.vue')
            },

            {
                // '文件',
                path: 'tool/default',
                component: () => import('@/pages/agency/tool/default.vue')
            },

            // 系统管理管理

            // 管理员
                {
                    // '管理员',
                    path: 'user/user',
                    component: () => import('@/pages/agency/user/user.vue')
                },
                {
                    // '日志',
                    path: 'user/log',
                    component: () => import('@/pages/agency/user/log.vue')
                },
                {
                    // '权限',
                    path: 'user/rank',
                    component: () => import('@/pages/agency/user/rank.vue')
                },
                {
                    // '权限',
                    path: 'user/rankPhone',
                    component: () => import('@/pages/agency/user/rankPhone.vue')
                },
            // 管理员

            // 学校
                {
                    // '学校',
                    path: 'area/area',
                    component: () => import('@/pages/agency/area/area.vue')
                },
                {
                    // '日志',
                    path: 'area/user/:areaId',
                    component: () => import('@/pages/agency/area/user.vue')
                },
            // 学校
            
        ],
    },

    // 管理端
    {

        meta: {
            title: '管理端'
        },
        path:'/area',
        component: () => import('@/pages/area/home.vue'),
        children: [
            {
                path: 'index/index',
                component: () => import('@/pages/area/index/index.vue')
            },

            // 文件
            {
                // '文件',
                path: 'file/file',
                component: () => import('@/pages/area/file/file.vue')
            },

            {
                // '文件',
                path: 'tool/default',
                component: () => import('@/pages/area/tool/default.vue')
            },

            {
                // '协议',
                path: 'tool/agreement',
                component: () => import('@/pages/area/tool/agreement.vue')
            },

            {
                // '视频',
                path: 'tool/video',
                component: () => import('@/pages/area/tool/video.vue')
            },

            {
                // '分类',
                path: 'tool/types',
                component: () => import('@/pages/area/tool/types.vue')
            },

            {
                // '反馈',
                path: 'tool/kui',
                component: () => import('@/pages/area/tool/kui.vue')
            },

            {
                // '反馈',
                path: 'tool/msg',
                component: () => import('@/pages/area/tool/msg.vue')
            },

            {
                // '反馈',
                path: 'tool/swiper',
                component: () => import('@/pages/area/tool/swiper.vue')
            },

            // 系统管理管理

            // 管理员
                {
                    // '管理员',
                    path: 'user/user',
                    component: () => import('@/pages/area/user/user.vue')
                },
                {
                    // '日志',
                    path: 'user/log',
                    component: () => import('@/pages/area/user/log.vue')
                },
                {
                    // '权限',
                    path: 'user/rank',
                    component: () => import('@/pages/area/user/rank.vue')
                },
            // 管理员

            // 代理
                {
                    path: 'port/sell/apply/:state',
                    component: () => import('@/pages/area/port/sell/apply.vue')
                },
                {
                    path: 'port/sell/sell',
                    component: () => import('@/pages/area/port/sell/sell.vue')
                },
                {
                    path: 'port/sell/user/:sellId',
                    component: () => import('@/pages/area/port/sell/user.vue')
                },
            // 代理

            // 区域运营中心
                {
                    path: 'port/serve/serve',
                    component: () => import('@/pages/area/port/serve/serve.vue')
                },
                {
                    // '日志',
                    path: 'port/serve/user/:serveId',
                    component: () => import('@/pages/area/port/serve/user.vue')
                },
            // 区域运营中心

            // 用户
                {
                    path: 'port/user/:state',
                    component: () => import('@/pages/area/port/user.vue')
                },
            // 用户

            // 充值审核
                {
                    path: 'recharge/order/:state/:istype',
                    component: () => import('@/pages/area/recharge/order.vue')
                },
            // 充值审核

            // 签约记录
                {
                    path: 'sign/log/:state',
                    component: () => import('@/pages/area/sign/log.vue')
                },
            // 签约记录

            // 排课管理
                {
                    path: 'order/index',
                    component: () => import('@/pages/area/order/index.vue')
                },
            // 排课管理
        ],
    },

    // 代理
    {

        meta: {
            title: '代理端'
        },
        path:'/sell',
        component: () => import('@/pages/sell/home.vue'),
        children: [
            {
                // '后台首页',
                path: 'index/index',
                component: () => import('@/pages/sell/index/index.vue')
            },

            // 文件
            {
                // '文件',
                path: 'tool/file',
                component: () => import('@/pages/sell/tool/file.vue')
            },

            {
                // '反馈',
                path: 'tool/msg',
                component: () => import('@/pages/sell/tool/msg.vue')
            },

            // 系统管理管理

            // 管理员
                {
                    // '管理员',
                    path: 'user/user',
                    component: () => import('@/pages/sell/user/user.vue')
                },
                {
                    // '记录',
                    path: 'user/info',
                    component: () => import('@/pages/sell/user/info.vue')
                },
                {
                    // '日志',
                    path: 'user/log',
                    component: () => import('@/pages/sell/user/log.vue')
                },
                {
                    // '权限',
                    path: 'user/rank',
                    component: () => import('@/pages/sell/user/rank.vue')
                },
            // 管理员

            // 学员
                {
                    // '学员',
                    path: 'member/user/:state',
                    component: () => import('@/pages/sell/member/user.vue')
                },
            // 学员

            // 代理体系
                {
                    // '代理体系',
                    path: 'next/apply',
                    component: () => import('@/pages/sell/next/apply.vue')
                },
                {
                    // '代理体系',
                    path: 'next/sign',
                    component: () => import('@/pages/sell/next/sign.vue')
                },
                {
                    // '代理体系',
                    path: 'next/signlog',
                    component: () => import('@/pages/sell/next/signlog.vue')
                },
            // 代理体系

            // 申请管理
                {
                    // '下级代理',
                    path: 'apply/sell',
                    component: () => import('@/pages/sell/apply/sell.vue')
                },

                {
                    // '充值订单',
                    path: 'apply/recharge',
                    component: () => import('@/pages/sell/apply/recharge.vue')
                },
            // 申请管理

            // 记录管理
                {
                    // '记录',
                    path: 'log/log/:state',
                    component: () => import('@/pages/sell/log/log.vue')
                },
            // 记录管理

            // 排课管理
                {
                    path: 'order/index',
                    component: () => import('@/pages/sell/order/index.vue')
                },
            // 排课管理
                

        ],
    },

    // 陪练
    {

        meta: {
            title: '交付中心端'
        },
        path:'/serve',
        component: () => import('@/pages/serve/home.vue'),
        children: [
            {
                // '后台首页',
                path: 'index/index',
                component: () => import('@/pages/serve/index/index.vue')
            },

            // 文件
            {
                // '文件',
                path: 'tool/file',
                component: () => import('@/pages/serve/tool/file.vue')
            },

            {
                // '反馈',
                path: 'tool/msg',
                component: () => import('@/pages/serve/tool/msg.vue')
            },

            // 系统管理管理

            // 管理员
                {
                    // '管理员',
                    path: 'user/user',
                    component: () => import('@/pages/serve/user/user.vue')
                },
                {
                    // '记录',
                    path: 'user/info',
                    component: () => import('@/pages/serve/user/info.vue')
                },
                {
                    // '日志',
                    path: 'user/log',
                    component: () => import('@/pages/serve/user/log.vue')
                },
                {
                    // '权限',
                    path: 'user/rank',
                    component: () => import('@/pages/serve/user/rank.vue')
                },
            // 管理员

            // 申请管理
                {
                    // '下级代理',
                    path: 'apply/sell',
                    component: () => import('@/pages/serve/apply/sell.vue')
                },

                {
                    // '充值订单',
                    path: 'apply/recharge',
                    component: () => import('@/pages/serve/apply/recharge.vue')
                },
            // 申请管理

            // 学员
                {
                    // '学员',
                    path: 'member/user/:state',
                    component: () => import('@/pages/serve/member/user.vue')
                },
                {
                    // '签约',
                    path: 'member/sign',
                    component: () => import('@/pages/serve/member/sign.vue')
                },
                {
                    // '签约记录',
                    path: 'member/signlog',
                    component: () => import('@/pages/serve/member/signlog.vue')
                },
                {
                    // '学员',
                    path: 'member/info',
                    component: () => import('@/pages/serve/member/info.vue')
                },
                {
                    // '组',
                    path: 'member/group',
                    component: () => import('@/pages/serve/member/group.vue')
                },
                {
                    // '组',
                    path: 'member/group_user/:groupId',
                    component: () => import('@/pages/serve/member/group_user.vue')
                },
                {
                    // '佣金',
                    path: 'member/sum',
                    component: () => import('@/pages/serve/member/sum.vue')
                },
            // 学员

            // 排课管理
                {
                    path: 'order/index',
                    component: () => import('@/pages/serve/order/index.vue')
                },
                {
                    path: 'order/teacher',
                    component: () => import('@/pages/serve/order/teacher.vue')
                },
            // 排课管理 
            
        ],
    },

]

const router = createRouter({
    history:createWebHashHistory(),
    routes
})

var setLogin = function(fun = ''){
    store.state.user = 0
    util.localSet('user',0);
    store.state.token = 0
    util.localSet('token',0);
    store.state.port = 0
    util.localSet('port',0);
    store.state.rank = 0
    util.localSet('rank',0);
    store.state.nav = 0
    util.localSet('nav',0);
    fun ? fun() : '' ;
}

// 端口 1总后台2后台3学校4学生5供应商

router.beforeEach(async (to, from, next) => {

    console.log('----------进入路由----------',to)

    if (to.meta.title) {
        document.title = to.meta.title
    }

    var path = to.path.split('/');
    var port_name = '';
    if(path.length >= 2){
        port_name = path[1];
    }

    if(to.path == '/login'){
        util.loginIs(function(isLogin){

            if(isLogin){

                next(util.loginUrl(true));
                
            }else{

                next();

            }
        },false)
    }else{
        util.loginIs(function(isLogin){

            var paramsCou = 0;
            console.log('params',to.params)
            if(to.params){

                for(var k in to.params){
                    if(k != 'state' && k != 'istype'){
                        paramsCou ++;
                    }
                }

            }

            path.splice(path.length - paramsCou, paramsCou);
            console.log('path',path)
            var urlKey = path.join('_');
            to.query.urlKey = urlKey;

            if(isLogin){
                
                // console.log('----------URL处理----------')
                // console.log('URL处理1',paramsCou)
                // console.log('URL处理2',urlKey)
                // console.log('URL处理3',port_name)
                // console.log('URL处理4',store.state.rank)
                // console.log('URL处理5',to.params)
                // console.log('URL处理6',to)
                // console.log('----------URL处理----------')
                if (typeof store.state.rank[port_name][urlKey] !== 'undefined') {
                    store.state.rankKey = urlKey
                    store.state.rankBut = store.state.rank[port_name][urlKey]
                    next();
                }else{
                    if(!store.state.rank[port_name]){
                        setLogin(function(){
                            next('/login');
                        })
                    }else{
                        alert('您没有权限！！！');
                        next(false);
                    }
                }
                
            }else{

                alert('您还没有登录, 请先登录');
                store.state.user = 0
                store.state.token = 0
                next('/login');

            }
        })
        
    }
})

export default router